
<nav class="navbar navbar-expand-lg navbar-dark" style="background-color: #563D7C;">
  <ul class="navbar-nav">
    <li class="nav-item active">
      <a class="nav-link" routerLink = '/'>Home <span class="sr-only">(current)</span></a>
    </li>
  </ul>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" routerLink="countries/India">India</a>
      </li>

    </ul>
  </div>
</nav>
